import React from 'react'
import { Box, CardMedia } from '@mui/material';
import styled from 'styled-components'
import {ErrorHandlingFormProps} from '../hoc/createErrorHandlingForm'
import {currentMedia} from '../../../../styledComponents/ResponsiveConvenience'
import {Colors, FontSize} from '../../../../styledComponents/Constants'
import {Clear, Panorama} from '@mui/icons-material'
import FormErrorMessage from '../FormErrorMessage'
import {withErrorSubscribe} from '../hoc/withErrorSubscribe'
import {Nullable} from '../../../../app/TypeHelpers'

interface Props {
    fileName?: Nullable<string>
    fileData?: Nullable<string | ArrayBuffer | null>
    filePath?: Nullable<string>
    fileIndex?: number
    onDelete?: (fileIndex: number) => void
}

const PPImagePreviewForResident: React.FC<Props & ErrorHandlingFormProps> = (props) => {
    const {fileName, fileData, filePath, fileIndex, onDelete, messages, hasError} = props

    const renderNoImages = () => {
        return (
            <Box>
                <StyledCardNoImages>
                    <SampleDiv>
                        <Panorama style={panoramaIconStyle}/>
                        <ImageMessage>画像がここに表示されます</ImageMessage>
                    </SampleDiv>
                </StyledCardNoImages>
            </Box>
        )
    }

    const handleDelete = () => {
        if (!onDelete || fileIndex === undefined) {
            return
        }
        onDelete(fileIndex)
    }

    const imagePath = (fileName && fileData)
        ? 'data:image/' + fileName.split('.').pop() + ';base64,' + fileData
        : filePath

    return <>
        <ImageSelectDiv>
            <StyledCardContent hasError={hasError}>
                {
                    imagePath ?
                        <>
                            <Box>
                                <PreviewImage src={String(imagePath)}/>
                            </Box>
                            <DeleteBtnDiv hasError={hasError} onClick={() => {
                                handleDelete()
                            }}>
                                <Clear style={clearIconStyle}/>
                            </DeleteBtnDiv>
                        </> :
                        <>{renderNoImages()}</>
                }
            </StyledCardContent>
        </ImageSelectDiv>
        <InputField>
            {
                messages &&
                <ErrorMessage
                    messages={messages.map((pair) => {
                        return {
                            message: pair.message,
                        }
                    })}
                />
            }
        </InputField>
    </>
}

interface PreviewImageProps {
    src: string
}

const PreviewImage: React.FC<PreviewImageProps> = props => {
    const imageExist: boolean = (props.src.length > 0)
    const imageSrc: string = imageExist
        ? props.src
        : ``

    return (
        <CardMedia
            style={{maxWidth: '285px', maxHeight: '170px'}}
            component={'img'}
            src={imageSrc}
        />
    )
}

const StyledCardNoImages = styled.div`
  background-color: #EEEEEE;
  margin:auto;
  width: 345px;
  height: 180px;
  display: flex;
  justify-content: center;
  align-items: center;
`

const StyledCardContent = styled.div<{ hasError?: boolean }>`
  background-color: ${props => {
    if (props.hasError) {
        return 'rgb(253,245,246)'
    } else {
        return 'rgba(241, 241, 241, 1)'
    }
}};
  ${props => props.hasError ? `outline: 1px solid rgb(215, 55, 74);` : ''}
  margin:auto;
  max-width: 345px;
  height: 180px;
  display: flex;
  position: relative;
  justify-content: center;
  align-items: center;
`

const ErrorMessage = styled(FormErrorMessage)`
  margin-left: 14px !important;
  text-align: left !important;
  width: 345px;
  font-size: ${FontSize.Small} !important;
  font-family: "Noto Sans JP",sans-serif !important;
  color: ${Colors.Alert} !important;
`

const ImageSelectDiv = styled.div`
  ${currentMedia.lessThan('sp')`
    :nth-child(n+3) {
      padding-top: 20px;
    }
  `}
  ${currentMedia.greaterThan('pc')`
    :not(:first-child) {
      padding-top: 20px;
    }
  `}
`

const InputField = styled.div`
  display: flex;
  justify-content: center;
  margin: auto;
`

const ImageMessage = styled.div`
  color: #BDBDBD;
  margin:auto;
`

const SampleDiv = styled.div`
  display:flex;
  flex-direction: column;
`

const clearIconStyle = {
    fontSize: FontSize.Big,
}

const panoramaIconStyle = {
    width: '88.5px',
    height: '73.5px',
    color: Colors.AccentLight,
    margin: 'auto',
}

const DeleteBtnDiv = styled.div<{ hasError?: boolean }>`
   color: ${props => props.hasError === true ? `${Colors.Alert}` : `${Colors.AccentDark}`};
   position: absolute;
   cursor: pointer;
   margin-right: 10px;
   top: 10px;
   right: 0;
`

export default withErrorSubscribe(PPImagePreviewForResident)
